const collectionConfigurationContainer = document.querySelector('.collection-configuration-container');

new Swiper(collectionConfigurationContainer, {
  slidesPerView: 2.5,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 4.5,
    },
    1280: {
      slidesPerView: 7.7,
    },
  },
});
